/* global Util */
import { setCookie, getCookie, THEME_MODE_NAME } from '@/js/utils/cookie';

(() => {
  const themeSwitcherElm = document.querySelector('.js-theme-switcher');

  if (!themeSwitcherElm) {
    return;
  }

  if (!Util.cssSupports('color', 'var(--color-var)')) {
    themeSwitcherElm.parentNode.removeChild(themeSwitcherElm);

    return;
  }

  const Modes = Object.freeze({ DEFAULT: 'default', DARK: 'dark' });
  const mode = getCookie(THEME_MODE_NAME) || Modes.DEFAULT;

  function setThemeMode(theme) {
    let themeMode = theme;

    if (!themeMode || !Modes[themeMode.toUpperCase()]) {
      themeMode = Modes.DEFAULT;
    }

    Util.toggleClass(themeSwitcherElm, 'btn--state-b', themeMode === Modes.DARK);
    document.body.setAttribute('data-theme', themeMode);
    setCookie(THEME_MODE_NAME, themeMode);
  }

  themeSwitcherElm.removeAttribute('disabled');
  setThemeMode(mode);

  themeSwitcherElm.addEventListener('click', e => {
    e.preventDefault();
    const themeMode = document.body.getAttribute('data-theme') === Modes.DEFAULT ? Modes.DARK : Modes.DEFAULT;

    setThemeMode(themeMode);
  });
})();
